export { default } from './left-right-card';
